<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.meetMap">
            <div class="item">会议名称：{{form.beforeStr.meetMap.title}}</div>
            <div class="item">会议类型：{{form.beforeStr.meetCategoryMap && form.beforeStr.meetCategoryMap.name}}</div>
            <div class="item">会议主图：<el-image style="width: 50px; height: 50px" v-if="form.beforeStr.meetImageMap" :src="form.beforeStr.meetImageMap.url" :preview-src-list="[form.beforeStr.meetImageMap.url]"></el-image></div>
            <div class="item">会议图：<el-image v-for="(item,index) in form.beforeStr.meetMap.banner_url.split(',')" :key="index" style="width: 50px; height: 50px;margin-right:5px" :src="item" :preview-src-list="[item]"></el-image></div>

            <div class="item">地址：{{form.beforeStr.meetMap.address}}</div>
            <div class="item">会议时间：{{form.beforeStr.meetMap.start_time}} ~ {{form.beforeStr.meetMap.end_time}}</div>
            <div class="item">报名时间：{{form.beforeStr.meetMap.sign_up_start_time}} ~ {{form.beforeStr.meetMap.sign_up_end_time}}</div>
            <div class="item">签到距离：{{form.beforeStr.meetMap.sign_up_radius}}km</div>
            <div class="item">携带人数：{{form.beforeStr.meetMap.max_carry_people}}</div>
            <div class="item">发布会议时间：{{form.beforeStr.meetMap.created_time}}</div>
          </template>
          <template v-if="form.beforeStr.meetFeeMap">
            <div class="title-box"><span class="txt1">报名费用</span></div>
            <div class="item" v-for="(item,index) in beforeFeeList" :key="index">{{item.nameStr}}：
              {{item.amount}}<span v-if="item.gift_account_type && item.typeStr">；
                赠送账户类型: {{accountTypeArr[item.gift_account_type]}}</span>
              <span v-if="item.gift_amount  && item.typeStr">【赠送金额: {{item.gift_amount}}元】</span>
            </div>
          </template>
          <template v-if="form.beforeStr.meetMap">
            <div class="title-box"><span class="txt1">会议详情</span></div>
            <div class="item" v-html="form.beforeStr.meetMap.content"></div>
          </template>
          <template v-if="form.beforeStr.lecturerMap">
            <div class="title-box"><span class="txt1">主讲老师</span></div>
            <div class="item">讲师姓名：{{form.beforeStr.lecturerMap.lecturer_real_name}}</div>
            <div class="item">讲师等级：{{form.beforeStr.lecturerMap.lecturer_level_name}}</div>
            <div class="item">联系电话：{{form.beforeStr.lecturerMap.lecturer_mobile}}</div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr ">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.afterStr.meetMap">
            <div class="item">会议名称：{{form.afterStr.meetMap.title}}</div>
            <div class="item">会议类型：{{ form.afterStr.meetCategoryMap && form.afterStr.meetCategoryMap.name}}</div>
            <div class="item">会议主图：<el-image style="width: 50px; height: 50px" v-if="form.afterStr.meetImageMap" :src="form.afterStr.meetImageMap.url" :preview-src-list="[form.afterStr.meetImageMap.url]"></el-image></div>
            <div class="item">会议图：<el-image v-for="(item,index) in form.afterStr.meetMap.banner_url.split(',')" :key="index" style="width: 50px; height: 50px;margin-right:5px" :src="item" :preview-src-list="[item]"></el-image></div>

            <div class="item">地址：{{form.afterStr.meetMap.address}}</div>
            <div class="item">会议时间：{{form.afterStr.meetMap.start_time}} ~ {{form.afterStr.meetMap.end_time}}</div>
            <div class="item">报名时间：{{form.afterStr.meetMap.sign_up_start_time}} ~ {{form.afterStr.meetMap.sign_up_end_time}}</div>
            <div class="item">签到距离：{{form.afterStr.meetMap.sign_up_radius}}km</div>
            <div class="item">携带人数：{{form.afterStr.meetMap.max_carry_people}}</div>
            <div class="item">发布会议时间：{{form.afterStr.meetMap.created_time}}</div>
          </template>
          <template v-if="form.afterStr.meetFeeMap">
            <div class="title-box"><span class="txt1">报名费用</span></div>
            <div class="item" v-for="(item,index) in afterFeeList" :key="index">{{item.nameStr}}：
              {{item.amount}}<span v-if="item.gift_account_type && item.typeStr">；
                赠送账户类型: {{accountTypeArr[item.gift_account_type]}}</span>
              <span v-if="item.gift_amount  && item.typeStr">【赠送金额: {{item.gift_amount}}元】</span>
            </div>
          </template>
          <template v-if="form.afterStr.meetMap">
            <div class="title-box"><span class="txt1">会议详情</span></div>
            <div class="item" v-html="form.afterStr.meetMap.content"></div>
          </template>
          <template v-if="form.afterStr.lecturerMap">
            <div class="title-box"><span class="txt1">主讲老师</span></div>
            <div class="item">讲师姓名：{{form.afterStr.lecturerMap.lecturer_real_name}}</div>
            <div class="item">讲师等级：{{form.afterStr.lecturerMap.lecturer_level_name}}</div>
            <div class="item">联系电话：{{form.afterStr.lecturerMap.lecturer_mobile}}</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      accountTypeArr: ['', '余额', '零售价', '赠送额度'],
      afterFeeList: [],
      beforeFeeList: []
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.afterFeeList = res.data.afterStr && res.data.afterStr.meetFeeMap ? this.calcFeeList(res.data.afterStr.meetFeeMap) : []
        this.beforeFeeList = res.data.beforeStr && res.data.beforeStr.meetFeeMap ? this.calcFeeList(res.data.beforeStr.meetFeeMap) : []
        this.form = res.data;


      })
    },
    calcFeeList(data) {
      if (!data) return
      data.forEach(item => {
        if (item.level_id === 8 && item.type === 20) {
          item.nameStr = '普通用户'
        }
        if (item.level_id === 7 && item.type === 20) {
          item.nameStr = '体验班'
          item.typeStr = 1
        }
        if (item.level_id === 6 && item.type === 20) {
          item.nameStr = '研修班'
          item.typeStr = 2
        }
        if (item.level_id === 0 && item.type === 20) {
          item.nameStr = '业务线'
        }
        if (item.level_id === 0 && item.type === 30) {
          item.nameStr = '技术线'
        }
        if (item.level_id === 0 && item.type === 10) {
          item.nameStr = '内部员工'
        }
      });
      return data
    },
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
